import React from "react";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { ButtonPrimary } from "components/form/Button";
import H3 from "components/headings/H3";

const RequestCreatedMessageModal = ({
  isOpen,
  closeModal,
  email,
}: {
  isOpen: boolean;
  closeModal: (data?: boolean) => void;
  email: string;
}) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-black bg-opacity-25 pointer-events-none"
              aria-hidden="true"
            />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-md bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title as="h3" className="">
                    <H3>We&lsquo;ve received your menu!</H3>
                  </Dialog.Title>
                  <div className="mt-4">
                    <p className="text-base text-neutral-80">
                      We&lsquo;ll send you an email to {email} when your menu is
                      built. Most menu take under 24 hours to build.
                    </p>
                  </div>
                  <div className="flex mt-8">
                    <div className="flex flex-col sm:flex-row ml-auto w-full sm:w-auto">
                      <ButtonPrimary
                        size="small"
                        onClick={() => closeModal(false)}
                        styles="!font-medium mt-4 sm:mt-0"
                      >
                        Got it!
                      </ButtonPrimary>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default RequestCreatedMessageModal;
